import React, { useEffect } from 'react';
import ApiProvider from '../api/ApiProvider';
import { CancelTokenSource } from 'axios';

export type AbortRequestPropsType = {
  cancelTokenSource: CancelTokenSource;
};

// const withAbortRequest = <T extends object>(
//   Component: React.ComponentType<T>
// ) => (props: T & Omit(AbortRequestPropsType, 'cancelTokenSource')) => {
//   const cancelTokenSource = ApiProvider.getCancelToken();

//   useEffect(() => {
//     return function willUnmount() {
//       cancelTokenSource.cancel();
//     };
//     // eslint-disable-next-line
//   }, []);

//   return (
//     <Component {...props} cancelTokenSource={cancelTokenSource} />
//   );
// };

// export default withAbortRequest;

// const withAbortRequest =
//   <T extends object>(Component: React.ComponentType<T & AbortRequestPropsType>) =>
//   (props: Omit<T, keyof AbortRequestPropsType>) => {
//     const cancelTokenSource = ApiProvider.getCancelToken();

//     useEffect(() => {
//       return function willUnmount() {
//         cancelTokenSource.cancel();
//       };
//       // eslint-disable-next-line
//     }, []);

//     return <Component {...props} cancelTokenSource={cancelTokenSource} />;
//   };

// export default withAbortRequest;

const withAbortRequest =
  <T extends {}>(
    Component: React.ComponentType<T>
  ): React.ComponentType <Omit<T, keyof AbortRequestPropsType>> =>
  (props: any) => {
    const cancelTokenSource = ApiProvider.getCancelToken();

    useEffect(() => {
      return function willUnmount() {
        cancelTokenSource.cancel();
      };
      // eslint-disable-next-line
    }, []);

    return <Component {...props} cancelTokenSource={cancelTokenSource} />;
  };

export default withAbortRequest;
